<template>
    <div class="border-0">
        <app-overlay-loader v-if="preloader"/>
        <div class="">
            <form ref="form" data-url="admin/app/comments" class="mb-0" :class="{'loading-opacity': preloader}">
                <div class="form-group form-group-comment align-items-center justify-content-end">
                    <div class="avatars-w-70 w-20 float-left">
                        <img :src="this.userPhoto" class="rounded-circle">
                    </div>
                    <div class="form-group-row">
                        <app-input id="textarea_field"
                                   class="w-70 textarea"
                                   type="textarea"
                                   :placeholder="$t('text_of_your_comment')"
                                   v-model="inputs.comment"/>

                        <button type="submit" class="btn btn-primary btn-sm" @click.prevent="submit">
                            {{ $t('submit_comment') }}
                        </button>
                    </div>

                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../../../core/mixins/form/FormMixin.js';
    import GlobalHelperMixin from '../../../../../../Mixins/global/GlobalHelperMixin';

    export default {
        name: "InputFields",
        mixins: [FormMixin, GlobalHelperMixin],
        props: {
           candidateId: String,
           status: Number,
           userName: String,
           userPhoto: String,
           candidateName: String
        },
        data() {
            return {
                preloader: false,
                inputs: {},
                tableCommentId: 'comments-table',
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                this.scrollToTop(true);

                if (this.inputs.comment){

                    this.inputs.status = this.status;
                    this.inputs.candidate_id = this.candidateId;
                    this.inputs.author_name = this.userName;
                    this.inputs.candidate_name = this.candidateName;

                }

                this.save(this.inputs);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.$hub.$emit('reload-'+this.tableCommentId);
                this.scrollToTop(false);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                this.inputs = {};
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>
